/*
        This service abstracts all the Configurator API calls,
        there are not many, so we thought it makes sense to centralize them here

 */



const APIService = {
    // lookup api to get selected attributes and product details
    async get_quote(quoteId){
        return await fetch(window.location.origin + '/api/v1/configurator/quotes/'+quoteId)
            .then(results => {
                return results.json();
            }).catch(function(){
                return false;
            })
    },

    async get_agent(){
        return  await fetch(window.location.origin + '/api/v1/configurator/agents/current', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        }).then(results => {
            return results.json();
        })
    },

    //this will create quote
    async save(data){

        // this saves both Patterns and non Patterns
        let method = 'POST'
        let url = window.location.origin + '/api/v1/configurator/quotes/save';
        if(data.isPattern && !data.groupId) {
            url = window.location.origin + '/api/v1/configurator/patterns/'+data.patternId+'/save';
        } else if (data.isPattern && data.groupId) {
            // this is when we EDIT patterns
            url = window.location.origin + '/api/v1/configurator/patterns/'+data.patternId+'/save/'+ data.groupId;
        } else if (data.hasElements && !data.elementSaveShouldUpdate) {
            url = window.location.origin + '/api/v1/configurator/quotes/new/element_groups'
        } else if (data.hasElements && data.elementSaveShouldUpdate){
            url = window.location.origin + '/api/v1/configurator/quotes/'+ data.quoteId + '/element_groups/' + data.elementGroupId
            method = 'PATCH'
        }

        return await fetch(url, {
            method: method,
            headers: {
                'Content-Type': 'application/json', 'Accept': 'application/json'
            },
            body: JSON.stringify(data),

        }).then(results => {
            return results.json();
        }).catch(err => {
            return false;
        });
    },
};

export default APIService;
